import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useMemo } from 'react';
import { VStack } from '@/components/Layout';
import { OperationArchivesContainer, SearchSchema } from '@/features/operation-archives';
import { PlanningOperationsCoreHeader } from '../-components/PlanningOperationsCoreHeader';
import { useGetOperationPackages } from '../-query';
import { usePlanningOperationsCoreArchives } from './-query';
export const Route = createFileRoute('/_stacktrace/planning-operations-core/archives/')({
  component: PlanningOperationsCoreArchives,
  validateSearch: zodValidator(SearchSchema)
});
function PlanningOperationsCoreArchives() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const archivesQuery = usePlanningOperationsCoreArchives({
    page: search.pageIndex + 1,
    pageSize: search.pageSize,
    textSearch: search.textSearch,
    operationPackageId: search.operationPackageId,
    anchorDateFrom: search.anchorDateFrom,
    anchorDateTo: search.anchorDateTo,
    orderBy: search.orderBy,
    orderDirection: search.orderDirection
  });
  const {
    data: operationPackagesData,
    isLoading: isOperationPackagesLoading
  } = useGetOperationPackages();
  const packageOptionsQuery = useMemo(() => ({
    data: operationPackagesData?.map(pkg => ({
      id: pkg.operationPackageId,
      name: pkg.name
    })),
    isPending: isOperationPackagesLoading
  }), [operationPackagesData, isOperationPackagesLoading]);
  return <VStack className="h-full">
      <PlanningOperationsCoreHeader />
      <OperationArchivesContainer searchParams={search} onNavigate={navigate} archivesQuery={archivesQuery} packageOptionsQuery={packageOptionsQuery} onRowClick={row => {
      navigate({
        to: '/planning-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId',
        params: {
          id: row.packageId,
          patternId: row.patternId,
          instanceId: row.instanceId
        }
      });
    }} />
    </VStack>;
}